import { render, staticRenderFns } from "./PodItog.vue?vue&type=template&id=338d25d3&scoped=true&"
import script from "./PodItog.vue?vue&type=script&lang=js&"
export * from "./PodItog.vue?vue&type=script&lang=js&"
import style0 from "./PodItog.vue?vue&type=style&index=0&id=338d25d3&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338d25d3",
  null
  
)

export default component.exports